<template>
    <div>
        <b-table
            bordered
            striped
            responsive
            :items="exams"
            :fields="examFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded">
        </b-table>
    </div>
</template>
<script>

import StudentProgramService from "@/services/StudentProgramService";

export default {
    name: "LetterGradeDetailTable",
    props: {
        sectionId: {
            type: Number,
        }
    },
    watch: {
        sectionId: {
            immediate: true,
            handler(val) {
                if (val !== null && val !== undefined && String(val).trim() !== "") {
                    this.get(val);
                }
            }
        }
    },
    data() {
        return {
            course: null,
            exams: [],
            examFields: [
                {
                    key: 'exam_type_name',
                    label: this.$t("exam_type"),
                },
                {
                    key: "score",
                    label: this.$t("score"),
                }
            ]
        };
    },
    methods: {
        get(id) {
            this.formLoading = true;
            StudentProgramService.getStudentDetailedScored(id)
                .then((response) => {
                    const data = response.data?.data;
                    if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0].exams)) {
                        this.exams = data[0].exams;
                    }

                    this.formLoading = false;
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.$toast.error(this.$t("api." + error.data.message));
                    }
                });
        }
    }
}
</script>

